import { EffectDef, makeGain } from './types';

/** 3-band parametric EQ: low shelf, peaking mid, high shelf. */
export const eq: EffectDef = {
  type: 'eq',
  name: 'EQ',
  params: [
    { key: 'lowGain', label: 'Low', min: -24, max: 24, default: 0, step: 0.5, unit: 'dB' },
    { key: 'lowFreq', label: 'Low F', min: 40, max: 400, default: 120, step: 1, unit: 'Hz' },
    { key: 'midGain', label: 'Mid', min: -24, max: 24, default: 0, step: 0.5, unit: 'dB' },
    { key: 'midFreq', label: 'Mid F', min: 200, max: 4000, default: 1000, step: 10, unit: 'Hz' },
    { key: 'midQ', label: 'Mid Q', min: 0.1, max: 10, default: 1, step: 0.1 },
    { key: 'highGain', label: 'High', min: -24, max: 24, default: 0, step: 0.5, unit: 'dB' },
    { key: 'highFreq', label: 'High F', min: 2000, max: 16000, default: 8000, step: 50, unit: 'Hz' },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);

    const low = ctx.createBiquadFilter();
    low.type = 'lowshelf';
    const mid = ctx.createBiquadFilter();
    mid.type = 'peaking';
    const high = ctx.createBiquadFilter();
    high.type = 'highshelf';

    input.connect(low);
    low.connect(mid);
    mid.connect(high);
    high.connect(output);

    const apply = (params: Record<string, number>) => {
      low.frequency.value = params.lowFreq;
      low.gain.value = params.lowGain;
      mid.frequency.value = params.midFreq;
      mid.Q.value = params.midQ;
      mid.gain.value = params.midGain;
      high.frequency.value = params.highFreq;
      high.gain.value = params.highGain;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        low.disconnect();
        mid.disconnect();
        high.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};